<mat-card class="mainclass">

  <div class="header">
    <div class="d-flex align-items-center">
      <div class="icon">
        <span class="material-symbols-outlined" style="cursor: default !important;">find_in_page </span>
      </div>
      <div class="heading">Audits</div>
    </div>
    <span class="material-symbols-outlined audit_icon" >
      settings
      </span>
  </div>
  <div class="table-container">
    <table>
        <tr >
          <td class="countvalue border-right">14<br>
              <div class="textsize " style="cursor: pointer;" >Total</div></td>
          <td class="countvalue border-right">{{7}}<br>
            <div class="textsize " style="cursor: pointer;" >Completed</div></td>
          <td class="countvalue border-right">{{4}}<br>
            <div class="textsize " style="cursor: pointer;">In Progress</div>
          </td>
          <td class="countvalue ">{{3}} <br>
            <div class="textsize " style="cursor: pointer;" > Pending</div></td>

        </tr>
    </table>
  </div>
</mat-card>